<template>
  <address v-if="props.value">
    <div v-if="user.props.first_name && user.props.last_name" class="name">
      {{ user.props.first_name }} {{ user.props.last_name }}
    </div>
    <div class="address">
      {{ props.value.address }}
      <template v-if="props.value.address2?.trim()">
        <br />{{ props.value.address2 }}
      </template>
    </div>
    <div class="area">
      {{ props.value.city }} {{ props.value.state }} {{ props.value.zip_code }}
    </div>
    <div v-if="user.props.email" class="email">
      {{ user.props.email }}
    </div>
    <div v-if="user.props.phone" class="phone">
      {{ formatPhone(user.props.phone) }}
    </div>
    <div v-if="!props.hideShippingDefault && props.value.default_shipping">
      <b class="default">Default</b>
    </div>
  </address>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user";
import { formatPhone } from "@/utils/formats";
import type { Address } from "@paparazzi/types/paparazzi.api.serializers";

const props = withDefaults(
  defineProps<{
    value: Address;
    hideBillingDefault?: boolean;
    hideShippingDefault?: boolean;
  }>(),
  {
    hideBillingDefault: false,
    hideShippingDefault: false,
  },
);

const user = useUserStore();
</script>

<style scoped>
address {
  color: #000;

  /* Paragraph 1 */
  font-family: Indivisible;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
}
.default {
  color: var(--Paparazzi-Pink, #ec008c);
  font-family: Indivisible;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
